export const objNameRoles = {
  master: 1,
  admin: 2,
  gestor_global: 3,
  gestor_interno: 4,
  app: 5,
  provedor_pipas: 6,
  atencion_ciudadana: 7,
  chofer_pipas: 8,
  gestor_pipas: 9,
  gestor_tramites: 10,
  alcalde_tlajomulco: 11,
  revisor_tramites: 12,
  seguimiento_tramites: 13,
  notificador_tramites: 14,
  gestor_global_independiente: 15,
  enlace_de_gobierno: 17,
}
